<template>
	<div class="ZZJG">
		<div class="content">
			<div class="content_2 c3 lh7">
				<div class="f30">组织机构</div>
				<div class="f20 mb45">ORGANIZING FRAME</div>
				<transition name="el-zoom-in-top">
					<div v-show="show" class="tz" style="transition: all 0.6s;-webkit-transition: all 0.6s;">
						<img class="hidden-xs-only" src="../../assets/ZZJG.jpg" style="max-width: 100%;" />
						<img class="show-xs-only" src="../../assets/ZZJG.jpg" style="max-width: 100%;" @click="look(require('../../assets/ZZJG.jpg'))" />
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				show: false
			}
		},
		created() {

		},
		mounted() {
			this.$nextTick(() => {
				this.show = true
			})
		},
		methods: {
			look(url) {
				// console.log(url)
				window.open(url)
			}
		}
	}
</script>

<style lang="scss">
	.ZZJG {
		padding: 65px 0;
		
		@media screen and (max-width: 768px) {
			.f30 {
				font-size: 7vw;
				line-height: 1.2;
				text-align: center;
				margin-bottom: 20px;
			}
			
			.f20 {
				font-size: 16px;
				text-align: center;
				line-height: 1.2;
				margin-bottom: 30px;
			}
			
			.f18 {
				font-size: 16px;
			}
			
			padding-left: 2vw;
			padding-right: 2vw;
			box-sizing: border-box;
			
			img {
				width: 80%;
				margin: 0 auto;
			}
		}
	}
</style>
